import { RESUME_URL } from '../../constants'
import {
  HeroDiv,
  HeroText,
  HeroTextDiv,
  HeroSubTextDiv,
  HeroSubText,
  HeroBtn
} from './HeroSection.elements'

const HeroSection = () => {
  return (
    <>
      <HeroDiv>
        <HeroTextDiv>
          <HeroText>
            HI,👋
            <br />
            I'M <span style={{ color: 'rgb(242 93 93 / 90%)' }}>TARUN</span>
          </HeroText>
        </HeroTextDiv>
        <HeroSubTextDiv>
          <HeroSubText>I build web and mobile apps.</HeroSubText>
          <HeroBtn onClick={() => window.open(RESUME_URL)}>VIEW RESUME</HeroBtn>
        </HeroSubTextDiv>
      </HeroDiv>
    </>
  )
}

export default HeroSection
